import { defineStore } from 'pinia';

interface Userinfo {
  history_bind_car: boolean;
  biz_status: number;
  reg_city: any;
  uid: string;
}

export const useUserStore = defineStore('user', {
  state: () => ({
    info: {
      history_bind_car: false,
      biz_status: 1,
      reg_city: {
        cityid: '',
      },
      uid: '',
    },
  }),
  actions: {
    setUserinfo(data: Userinfo) {
      this.info = data;
    },
  },
});
